export default {
    formats: {
        'ps-AR': {
            'CtryNm': 'AFGHANISTAN',
            'CcyNm': 'Afghani',
            'currency': {
                'style': 'currency',
                'currency': 'AFN'
            }
        },
        'sq-AL': {
            'CtryNm': 'ALBANIA',
            'CcyNm': 'Lek',
            'currency': {
                'style': 'currency',
                'currency': 'ALL'
            }

        },
        'ar-DZ': {
            'CtryNm': 'ALGERIA',
            'CcyNm': 'Algerian Dinar',
            'currency': {
                'style': 'currency',
                'currency': 'DZD'
            }
        },
        'pt-AO': {
            'CtryNm': 'ANGOLA',
            'CcyNm': 'Kwanza',
            'currency': {
                'style': 'currency',
                'currency': 'AOA'
            }
        },
        'es-AR': {
            'CtryNm': 'ARGENTINA',
            'CcyNm': 'Argentine Peso',
            'currency': {
                'style': 'currency',
                'currency': 'ARS'
            }
        },
        'hy-AM': {
            'CtryNm': 'ARMENIA',
            'CcyNm': 'Armenian Dram',
            'currency': {
                'style': 'currency',
                'currency': 'AMD'
            }
        },
        'en-AU': {
            'CtryNm': 'AUSTRALIA',
            'CcyNm': 'Australian Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'AUD'
            }
        },
        'de-AT': {
            'CtryNm': 'AUSTRIA',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'az-AZ': {
            'CtryNm': 'AZERBAIJAN',
            'CcyNm': 'Azerbaijan Manat',
            'currency': {
                'style': 'currency',
                'currency': 'AZN'
            }
        },
        'ar-BH': {
            'CtryNm': 'BAHRAIN',
            'CcyNm': 'Bahraini Dinar',
            'currency': {
                'style': 'currency',
                'currency': 'BHD'
            }
        },
        'bn-BD': {
            'CtryNm': 'BANGLADESH',
            'CcyNm': 'Taka',
            'currency': {
                'style': 'currency',
                'currency': 'BDT'
            }
        },
        'be-BY': {
            'CtryNm': 'BELARUS',
            'CcyNm': 'Belarusian Ruble',
            'currency': {
                'style': 'currency',
                'currency': 'BYN'
            }
        },
        'fr-BE': {
            'CtryNm': 'BELGIUM',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'en-BZ': {
            'CtryNm': 'BELIZE',
            'CcyNm': 'Belize Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'BZD'
            }
        },
        'dz-BT': {
            'CtryNm': 'BHUTAN',
            'CcyNm': 'Indian Rupee',
            'currency': {
                'style': 'currency',
                'currency': 'INR'
            }
        },
        'es-BO': {
            'CtryNm': 'BOLIVIA (PLURINATIONAL STATE OF)',
            'CcyNm': 'Boliviano',
            'currency': {
                'style': 'currency',
                'currency': 'BOB'
            }
        },
        'hr-BA': {
            'CtryNm': 'BOSNIA AND HERZEGOVINA',
            'CcyNm': 'Convertible Mark',
            'currency': {
                'style': 'currency',
                'currency': 'BAM'
            }
        },
        'en-BW': {
            'CtryNm': 'BOTSWANA',
            'CcyNm': 'Pula',
            'currency': {
                'style': 'currency',
                'currency': 'BWP'
            }
        },
        'pt-BR': {
            'CtryNm': 'BRAZIL',
            'CcyNm': 'Brazilian Real',
            'currency': {
                'style': 'currency',
                'currency': 'BRL'
            }
        },
        'en-IO': {
            'CtryNm': 'BRITISH INDIAN OCEAN TERRITORY (THE)',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'ms-BN': {
            'CtryNm': 'BRUNEI DARUSSALAM',
            'CcyNm': 'Brunei Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'BND'
            }
        },
        'bg-BG': {
            'CtryNm': 'BULGARIA',
            'CcyNm': 'Bulgarian Lev',
            'currency': {
                'style': 'currency',
                'currency': 'BGN'
            }
        },
        'fr-BF': {
            'CtryNm': 'BURKINA FASO',
            'CcyNm': 'CFA Franc BCEAO',
            'currency': {
                'style': 'currency',
                'currency': 'XOF'
            }
        },
        'rn-BI': {
            'CtryNm': 'BURUNDI',
            'CcyNm': 'Burundi Franc',
            'currency': {
                'style': 'currency',
                'currency': 'BIF'
            }
        },
        'km-KH': {
            'CtryNm': 'CAMBODIA',
            'CcyNm': 'Riel',
            'currency': {
                'style': 'currency',
                'currency': 'KHR'
            }
        },
        'en-CM': {
            'CtryNm': 'CAMEROON',
            'CcyNm': 'CFA Franc BEAC',
            'currency': {
                'style': 'currency',
                'currency': 'XAF'
            }
        },
        'en-CA': {
            'CtryNm': 'CANADA',
            'CcyNm': 'Canadian Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'CAD'
            }
        },
        'en-KY': {
            'CtryNm': 'CAYMAN ISLANDS (THE)',
            'CcyNm': 'Cayman Islands Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'KYD'
            }
        },
        'fr-CF': {
            'CtryNm': 'CENTRAL AFRICAN REPUBLIC (THE)',
            'CcyNm': 'CFA Franc BEAC',
            'currency': {
                'style': 'currency',
                'currency': 'XAF'
            }
        },
        'ar-TD': {
            'CtryNm': 'CHAD',
            'CcyNm': 'CFA Franc BEAC',
            'currency': {
                'style': 'currency',
                'currency': 'XAF'
            }
        },
        'es-CL': {
            'CtryNm': 'CHILE',
            'CcyNm': 'Chilean Peso',
            'currency': {
                'style': 'currency',
                'currency': 'CLP'
            }
        },
        'zh-CN': {
            'CtryNm': 'CHINA',
            'CcyNm': 'Yuan Renminbi',
            'currency': {
                'style': 'currency',
                'currency': 'CNY'
            }
        },
        'en-CX': {
            'CtryNm': 'CHRISTMAS ISLAND',
            'CcyNm': 'Australian Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'AUD'
            }
        },
        'en-CC': {
            'CtryNm': 'COCOS (KEELING) ISLANDS (THE)',
            'CcyNm': 'Australian Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'AUD'
            }
        },
        'es-CO': {
            'CtryNm': 'COLOMBIA',
            'CcyNm': 'Colombian Peso',
            'currency': {
                'style': 'currency',
                'currency': 'COP'
            }
        },
        'fr-KM': {
            'CtryNm': 'COMOROS (THE)',
            'CcyNm': 'Comorian Franc ',
            'currency': {
                'style': 'currency',
                'currency': 'KMF'
            }
        },
        'fr-CD': {
            'CtryNm': 'CONGO (THE DEMOCRATIC REPUBLIC OF THE)',
            'CcyNm': 'Congolese Franc',
            'currency': {
                'style': 'currency',
                'currency': 'CDF'
            }
        },
        'fr-CG': {
            'CtryNm': 'CONGO (THE)',
            'CcyNm': 'CFA Franc BEAC',
            'currency': {
                'style': 'currency',
                'currency': 'XAF'
            }
        },
        'en-CK': {
            'CtryNm': 'COOK ISLANDS (THE)',
            'CcyNm': 'New Zealand Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'NZD'
            }
        },
        'es-CR': {
            'CtryNm': 'COSTA RICA',
            'CcyNm': 'Costa Rican Colon',
            'currency': {
                'style': 'currency',
                'currency': 'CRC'
            }
        },
        'fr-CI': {
            'CtryNm': "CÔTE D'IVOIRE",
            'CcyNm': 'CFA Franc BCEAO',
            'currency': {
                'style': 'currency',
                'currency': 'XOF'
            }
        },
        'hr-HR': {
            'CtryNm': 'CROATIA',
            'CcyNm': 'Kuna',
            'currency': {
                'style': 'currency',
                'currency': 'HRK'
            }
        },
        'es-CU': {
            'CtryNm': 'CUBA',
            'CcyNm': 'Cuban Peso',
            'currency': {
                'style': 'currency',
                'currency': 'CUP'
            }
        },
        'nl-CW': {
            'CtryNm': 'CURAÇAO',
            'CcyNm': 'Netherlands Antillean Guilder',
            'currency': {
                'style': 'currency',
                'currency': 'ANG'
            }
        },
        'el-CY': {
            'CtryNm': 'CYPRUS',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'cs-CZ': {
            'CtryNm': 'CZECHIA',
            'CcyNm': 'Czech Koruna',
            'currency': {
                'style': 'currency',
                'currency': 'CZK'
            }
        },
        'da-DK': {
            'CtryNm': 'DENMARK',
            'CcyNm': 'Danish Krone',
            'currency': {
                'style': 'currency',
                'currency': 'DKK'
            }
        },
        'fr-DJ': {
            'CtryNm': 'DJIBOUTI',
            'CcyNm': 'Djibouti Franc',
            'currency': {
                'style': 'currency',
                'currency': 'DJF'
            }
        },
        'fr-DA': {
            'CtryNm': 'DOMINICA',
            'CcyNm': 'East Caribbean Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'XCD'
            }
        },
        'es-DO': {
            'CtryNm': 'DOMINICAN REPUBLIC (THE)',
            'CcyNm': 'Dominican Peso',
            'currency': {
                'style': 'currency',
                'currency': 'DOP'
            }
        },
        'es-EC': {
            'CtryNm': 'ECUADOR',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'ar-EG': {
            'CtryNm': 'EGYPT',
            'CcyNm': 'Egyptian Pound',
            'currency': {
                'style': 'currency',
                'currency': 'EGP'
            }
        },
        'es-SV': {
            'CtryNm': 'EL SALVADOR',
            'CcyNm': 'El Salvador Colon',
            'currency': {
                'style': 'currency',
                'currency': 'SVC'
            }
        },
        'es-GQ': {
            'CtryNm': 'EQUATORIAL GUINEA',
            'CcyNm': 'CFA Franc BEAC',
            'currency': {
                'style': 'currency',
                'currency': 'XAF'
            }
        },
        'en-ER': {
            'CtryNm': 'ERITREA',
            'CcyNm': 'Nakfa',
            'currency': {
                'style': 'currency',
                'currency': 'ERN'
            }
        },
        'et-EE': {
            'CtryNm': 'ESTONIA',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'am-ET': {
            'CtryNm': 'ETHIOPIA',
            'CcyNm': 'Ethiopian Birr',
            'currency': {
                'style': 'currency',
                'currency': 'ETB'
            }
        },
        'en-FK': {
            'CtryNm': 'FALKLAND ISLANDS (THE) [MALVINAS]',
            'CcyNm': 'Falkland Islands Pound',
            'currency': {
                'style': 'currency',
                'currency': 'FKP'
            }
        },
        'fo-FO': {
            'CtryNm': 'FAROE ISLANDS (THE)',
            'CcyNm': 'Danish Krone',
            'currency': {
                'style': 'currency',
                'currency': 'DKK'
            }
        },
        'en-FJ': {
            'CtryNm': 'FIJI',
            'CcyNm': 'Fiji Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'FJD'
            }
        },
        'fi-FI': {
            'CtryNm': 'FINLAND',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'fr-FR': {
            'CtryNm': 'FRANCE',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'fr-GF': {
            'CtryNm': 'FRENCH GUIANA',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'fr-PF': {
            'CtryNm': 'FRENCH POLYNESIA',
            'CcyNm': 'CFP Franc',
            'currency': {
                'style': 'currency',
                'currency': 'XPF'
            }
        },
        'fr-GA': {
            'CtryNm': 'GABON',
            'CcyNm': 'CFA Franc BEAC',
            'currency': {
                'style': 'currency',
                'currency': 'XAF'
            }
        },
        'en-GM': {
            'CtryNm': 'GAMBIA (THE)',
            'CcyNm': 'Dalasi',
            'currency': {
                'style': 'currency',
                'currency': 'GMD'
            }
        },
        'ka-GE': {
            'CtryNm': 'GEORGIA',
            'CcyNm': 'Lari',
            'currency': {
                'style': 'currency',
                'currency': 'GEL'
            }
        },
        'de-DE': {
            'CtryNm': 'GERMANY',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'en-GH': {
            'CtryNm': 'GHANA',
            'CcyNm': 'Ghana Cedi',
            'currency': {
                'style': 'currency',
                'currency': 'GHS'
            }
        },
        'en-GI': {
            'CtryNm': 'GIBRALTAR',
            'CcyNm': 'Gibraltar Pound',
            'currency': {
                'style': 'currency',
                'currency': 'GIP'
            }
        },
        'el-GR': {
            'CtryNm': 'GREECE',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'da-GL': {
            'CtryNm': 'GREENLAND',
            'CcyNm': 'Danish Krone',
            'currency': {
                'style': 'currency',
                'currency': 'DKK'
            }
        },
        'en-GD': {
            'CtryNm': 'GRENADA',
            'CcyNm': 'East Caribbean Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'XCD'
            }
        },
        'fr-GP': {
            'CtryNm': 'GUADELOUPE',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'en-GU': {
            'CtryNm': 'GUAM',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'es-GT': {
            'CtryNm': 'GUATEMALA',
            'CcyNm': 'Quetzal',
            'currency': {
                'style': 'currency',
                'currency': 'GTQ'
            }
        },
        'en-GG': {
            'CtryNm': 'GUERNSEY',
            'CcyNm': 'Pound Sterling',
            'currency': {
                'style': 'currency',
                'currency': 'GBP'
            }
        },
        'fr-GN': {
            'CtryNm': 'GUINEA',
            'CcyNm': 'Guinean Franc',
            'currency': {
                'style': 'currency',
                'currency': 'GNF'
            }
        },
        'pt-GW': {
            'CtryNm': 'GUINEA-BISSAU',
            'CcyNm': 'CFA Franc BCEAO',
            'currency': {
                'style': 'currency',
                'currency': 'XOF'
            }
        },
        'en-GY': {
            'CtryNm': 'GUYANA',
            'CcyNm': 'Guyana Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'GYD'
            }
        },
        'fr-HT': {
            'CtryNm': 'HAITI',
            'CcyNm': 'Gourde',
            'currency': {
                'style': 'currency',
                'currency': 'HTG'
            }
        },
        'es-HN': {
            'CtryNm': 'HONDURAS',
            'CcyNm': 'Lempira',
            'currency': {
                'style': 'currency',
                'currency': 'HNL'
            }
        },
        'en-HK': {
            'CtryNm': 'HONG KONG',
            'CcyNm': 'Hong Kong Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'HKD'
            }
        },
        'hu-HU': {
            'CtryNm': 'HUNGARY',
            'CcyNm': 'Forint',
            'currency': {
                'style': 'currency',
                'currency': 'HUF'
            }
        },
        'is-IS': {
            'CtryNm': 'ICELAND',
            'CcyNm': 'Iceland Krona',
            'currency': {
                'style': 'currency',
                'currency': 'ISK'
            }
        },
        'en-IN': {
            'CtryNm': 'INDIA',
            'CcyNm': 'Indian Rupee',
            'currency': {
                'style': 'currency',
                'currency': 'INR'
            }
        },
        'in-ID': {
            'CtryNm': 'INDONESIA',
            'CcyNm': 'Rupiah',
            'currency': {
                'style': 'currency',
                'currency': 'IDR'
            }
        },
        'fa-IR': {
            'CtryNm': 'IRAN (ISLAMIC REPUBLIC OF)',
            'CcyNm': 'Iranian Rial',
            'currency': {
                'style': 'currency',
                'currency': 'IRR'
            }
        },
        'ar-IQ': {
            'CtryNm': 'IRAQ',
            'CcyNm': 'Iraqi Dinar',
            'currency': {
                'style': 'currency',
                'currency': 'IQD'
            }
        },
        'en-IE': {
            'CtryNm': 'IRELAND',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'en-IM': {
            'CtryNm': 'ISLE OF MAN',
            'CcyNm': 'Pound Sterling',
            'currency': {
                'style': 'currency',
                'currency': 'GBP'
            }
        },
        'ar-IL': {
            'CtryNm': 'ISRAEL',
            'CcyNm': 'New Israeli Sheqel',
            'currency': {
                'style': 'currency',
                'currency': 'ILS'
            }
        },
        'it-IT': {
            'CtryNm': 'ITALY',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'en-JM': {
            'CtryNm': 'JAMAICA',
            'CcyNm': 'Jamaican Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'JMD'
            }
        },
        'ja-JP': {
            'CtryNm': 'JAPAN',
            'CcyNm': 'Yen',
            'currency': {
                'style': 'currency',
                'currency': 'JPY'
            }
        },
        'en-JE': {
            'CtryNm': 'JERSEY',
            'CcyNm': 'Pound Sterling',
            'currency': {
                'style': 'currency',
                'currency': 'GBP'
            }
        },
        'ar-JO': {
            'CtryNm': 'JORDAN',
            'CcyNm': 'Jordanian Dinar',
            'currency': {
                'style': 'currency',
                'currency': 'JOD'
            }
        },
        'ru-KZ': {
            'CtryNm': 'KAZAKHSTAN',
            'CcyNm': 'Tenge',
            'currency': {
                'style': 'currency',
                'currency': 'KZT'
            }
        },
        'en-KE': {
            'CtryNm': 'KENYA',
            'CcyNm': 'Kenyan Shilling',
            'currency': {
                'style': 'currency',
                'currency': 'KES'
            }
        },
        'en-KI': {
            'CtryNm': 'KIRIBATI',
            'CcyNm': 'Australian Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'AUD'
            }
        },
        'ko-KP': {
            'CtryNm': 'KOREA (THE DEMOCRATIC PEOPLE’S REPUBLIC OF)',
            'CcyNm': 'North Korean Won',
            'currency': {
                'style': 'currency',
                'currency': 'KPW'
            }
        },
        'ko-KR': {
            'CtryNm': 'KOREA (THE REPUBLIC OF)',
            'CcyNm': 'Won',
            'currency': {
                'style': 'currency',
                'currency': 'KRW'
            }
        },
        'ar-KW': {
            'CtryNm': 'KUWAIT',
            'CcyNm': 'Kuwaiti Dinar',
            'currency': {
                'style': 'currency',
                'currency': 'KWD'
            }
        },
        'ru-KG': {
            'CtryNm': 'KYRGYZSTAN',
            'CcyNm': 'Som',
            'currency': {
                'style': 'currency',
                'currency': 'KGS'
            }
        },
        'lo-LA': {
            'CtryNm': 'LAO PEOPLE’S DEMOCRATIC REPUBLIC (THE)',
            'CcyNm': 'Lao Kip',
            'currency': {
                'style': 'currency',
                'currency': 'LAK'
            }
        },
        'lv-LV': {
            'CtryNm': 'LATVIA',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'ar-LB': {
            'CtryNm': 'LEBANON',
            'CcyNm': 'Lebanese Pound',
            'currency': {
                'style': 'currency',
                'currency': 'LBP'
            }
        },
        'en-LS': {
            'CtryNm': 'LESOTHO',
            'CcyNm': 'Loti',
            'currency': {
                'style': 'currency',
                'currency': 'LSL'
            }
        },
        'en-LSr': {
            'CtryNm': 'LESOTHO',
            'CcyNm': 'Rand',
            'currency': {
                'style': 'currency',
                'currency': 'ZAR'
            }
        },
        'en-LR': {
            'CtryNm': 'LIBERIA',
            'CcyNm': 'Liberian Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'LRD'
            }
        },
        'ar-LY': {
            'CtryNm': 'LIBYA',
            'CcyNm': 'Libyan Dinar',
            'currency': {
                'style': 'currency',
                'currency': 'LYD'
            }
        },
        'de-LI': {
            'CtryNm': 'LIECHTENSTEIN',
            'CcyNm': 'Swiss Franc',
            'currency': {
                'style': 'currency',
                'currency': 'CHF'
            }
        },
        'lt-LT': {
            'CtryNm': 'LITHUANIA',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'fr-LU': {
            'CtryNm': 'LUXEMBOURG',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'mk-MK': {
            'CtryNm': 'MACEDONIA (THE FORMER YUGOSLAV REPUBLIC OF)',
            'CcyNm': 'Denar',
            'currency': {
                'style': 'currency',
                'currency': 'MKD'
            }
        },
        'en-MG': {
            'CtryNm': 'MADAGASCAR',
            'CcyNm': 'Malagasy Ariary',
            'currency': {
                'style': 'currency',
                'currency': 'MGA'
            }
        },
        'en-MW': {
            'CtryNm': 'MALAWI',
            'CcyNm': 'Malawi Kwacha',
            'currency': {
                'style': 'currency',
                'currency': 'MWK'
            }
        },
        'ms-MY': {
            'CtryNm': 'MALAYSIA',
            'CcyNm': 'Malaysian Ringgit',
            'currency': {
                'style': 'currency',
                'currency': 'MYR'
            }
        },
        'fr-ML': {
            'CtryNm': 'MALI',
            'CcyNm': 'CFA Franc BCEAO',
            'currency': {
                'style': 'currency',
                'currency': 'XOF'
            }
        },
        'en-MT': {
            'CtryNm': 'MALTA',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'en-MH': {
            'CtryNm': 'MARSHALL ISLANDS (THE)',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'fr-MQ': {
            'CtryNm': 'MARTINIQUE',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'fr-MR': {
            'CtryNm': 'MAURITANIA',
            'CcyNm': 'Ouguiya',
            'currency': {
                'style': 'currency',
                'currency': 'MRU'
            }
        },
        'fr-MU': {
            'CtryNm': 'MAURITIUS',
            'CcyNm': 'Mauritius Rupee',
            'currency': {
                'style': 'currency',
                'currency': 'MUR'
            }
        },
        'fr-YT': {
            'CtryNm': 'MAYOTTE',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'es-MX': {
            'CtryNm': 'MEXICO',
            'CcyNm': 'Mexican Peso',
            'currency': {
                'style': 'currency',
                'currency': 'MXN'
            }
        },
        'en-FM': {
            'CtryNm': 'MICRONESIA (FEDERATED STATES OF)',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'ro-MD': {
            'CtryNm': 'MOLDOVA (THE REPUBLIC OF)',
            'CcyNm': 'Moldovan Leu',
            'currency': {
                'style': 'currency',
                'currency': 'MDL'
            }
        },
        'fr-MC': {
            'CtryNm': 'MONACO',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'mn-MN': {
            'CtryNm': 'MONGOLIA',
            'CcyNm': 'Tugrik',
            'currency': {
                'style': 'currency',
                'currency': 'MNT'
            }
        },
        'sr-ME': {
            'CtryNm': 'MONTENEGRO',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'en-MS': {
            'CtryNm': 'MONTSERRAT',
            'CcyNm': 'East Caribbean Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'XCD'
            }
        },
        'fr-MA': {
            'CtryNm': 'MOROCCO',
            'CcyNm': 'Moroccan Dirham',
            'currency': {
                'style': 'currency',
                'currency': 'MAD'
            }
        },
        'pt-MZ': {
            'CtryNm': 'MOZAMBIQUE',
            'CcyNm': 'Mozambique Metical',
            'currency': {
                'style': 'currency',
                'currency': 'MZN'
            }
        },
        'my-MM': {
            'CtryNm': 'MYANMAR',
            'CcyNm': 'Kyat',
            'currency': {
                'style': 'currency',
                'currency': 'MMK'
            }
        },
        'en-NA': {
            'CtryNm': 'NAMIBIA',
            'CcyNm': 'Namibia Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'NAD'
            }
        },
        'en-NR': {
            'CtryNm': 'NAURU',
            'CcyNm': 'Australian Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'AUD'
            }
        },
        'ne-NP': {
            'CtryNm': 'NEPAL',
            'CcyNm': 'Nepalese Rupee',
            'currency': {
                'style': 'currency',
                'currency': 'NPR'
            }
        },
        'nl-NL': {
            'CtryNm': 'NETHERLANDS (THE)',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'fr-NC': {
            'CtryNm': 'NEW CALEDONIA',
            'CcyNm': 'CFP Franc',
            'currency': {
                'style': 'currency',
                'currency': 'XPF'
            }
        },
        'en-NZ': {
            'CtryNm': 'NEW ZEALAND',
            'CcyNm': 'New Zealand Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'NZD'
            }
        },
        'es-NI': {
            'CtryNm': 'NICARAGUA',
            'CcyNm': 'Cordoba Oro',
            'currency': {
                'style': 'currency',
                'currency': 'NIO'
            }
        },
        'fr-NE': {
            'CtryNm': 'NIGER (THE)',
            'CcyNm': 'CFA Franc BCEAO',
            'currency': {
                'style': 'currency',
                'currency': 'XOF'
            }
        },
        'en-NG': {
            'CtryNm': 'NIGERIA',
            'CcyNm': 'Naira',
            'currency': {
                'style': 'currency',
                'currency': 'NGN'
            }
        },
        'en-NU': {
            'CtryNm': 'NIUE',
            'CcyNm': 'New Zealand Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'NZD'
            }
        },
        'en-NF': {
            'CtryNm': 'NORFOLK ISLAND',
            'CcyNm': 'Australian Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'AUD'
            }
        },
        'en-MP': {
            'CtryNm': 'NORTHERN MARIANA ISLANDS (THE)',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'nn-NO': {
            'CtryNm': 'NORWAY',
            'CcyNm': 'Norwegian Krone',
            'currency': {
                'style': 'currency',
                'currency': 'NOK'
            }
        },
        'ar-OM': {
            'CtryNm': 'OMAN',
            'CcyNm': 'Rial Omani',
            'currency': {
                'style': 'currency',
                'currency': 'OMR'
            }
        },
        'en-PK': {
            'CtryNm': 'PAKISTAN',
            'CcyNm': 'Pakistan Rupee',
            'currency': {
                'style': 'currency',
                'currency': 'PKR'
            }
        },
        'en-PW': {
            'CtryNm': 'PALAU',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'es-PA': {
            'CtryNm': 'PANAMA',
            'CcyNm': 'Balboa',
            'currency': {
                'style': 'currency',
                'currency': 'PAB'
            }
        },
        'en-PG': {
            'CtryNm': 'PAPUA NEW GUINEA',
            'CcyNm': 'Kina',
            'currency': {
                'style': 'currency',
                'currency': 'PGK'
            }
        },
        'es-PY': {
            'CtryNm': 'PARAGUAY',
            'CcyNm': 'Guarani',
            'currency': {
                'style': 'currency',
                'currency': 'PYG'
            }
        },
        'es-PE': {
            'CtryNm': 'PERU',
            'CcyNm': 'Sol',
            'currency': {
                'style': 'currency',
                'currency': 'PEN'
            }
        },
        'en-PH': {
            'CtryNm': 'PHILIPPINES (THE)',
            'CcyNm': 'Philippine Peso',
            'currency': {
                'style': 'currency',
                'currency': 'PHP'
            }
        },
        'en-PN': {
            'CtryNm': 'PITCAIRN',
            'CcyNm': 'New Zealand Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'NZD'
            }
        },
        'pl-PL': {
            'CtryNm': 'POLAND',
            'CcyNm': 'Zloty',
            'currency': {
                'style': 'currency',
                'currency': 'PLN'
            }
        },
        'pt-PT': {
            'CtryNm': 'PORTUGAL',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'es-PR': {
            'CtryNm': 'PUERTO RICO',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'ar-QA': {
            'CtryNm': 'QATAR',
            'CcyNm': 'Qatari Rial',
            'currency': {
                'style': 'currency',
                'currency': 'QAR'
            }
        },
        'fr-RE': {
            'CtryNm': 'RÉUNION',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'ro-RO': {
            'CtryNm': 'ROMANIA',
            'CcyNm': 'Romanian Leu',
            'currency': {
                'style': 'currency',
                'currency': 'RON'
            }
        },
        'ru-RU': {
            'CtryNm': 'RUSSIAN FEDERATION (THE)',
            'CcyNm': 'Russian Ruble',
            'currency': {
                'style': 'currency',
                'currency': 'RUB'
            }
        },
        'en-RW': {
            'CtryNm': 'RWANDA',
            'CcyNm': 'Rwanda Franc',
            'currency': {
                'style': 'currency',
                'currency': 'RWF'
            }
        },
        'fr-BL': {
            'CtryNm': 'SAINT BARTHÉLEMY',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'en-SH': {
            'CtryNm': 'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA',
            'CcyNm': 'Saint Helena Pound',
            'currency': {
                'style': 'currency',
                'currency': 'SHP'
            }
        },
        'en-KN': {
            'CtryNm': 'SAINT KITTS AND NEVIS',
            'CcyNm': 'East Caribbean Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'XCD'
            }
        },
        'en-LC': {
            'CtryNm': 'SAINT LUCIA',
            'CcyNm': 'East Caribbean Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'XCD'
            }
        },
        'fr-MF': {
            'CtryNm': 'SAINT MARTIN (FRENCH PART)',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'fr-PM': {
            'CtryNm': 'SAINT PIERRE AND MIQUELON',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'en-VC': {
            'CtryNm': 'SAINT VINCENT AND THE GRENADINES',
            'CcyNm': 'East Caribbean Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'XCD'
            }
        },
        'en-WS': {
            'CtryNm': 'SAMOA',
            'CcyNm': 'Tala',
            'currency': {
                'style': 'currency',
                'currency': 'WST'
            }
        },
        'it-SM': {
            'CtryNm': 'SAN MARINO',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'ar-SA': {
            'CtryNm': 'SAUDI ARABIA',
            'CcyNm': 'Saudi Riyal',
            'currency': {
                'style': 'currency',
                'currency': 'SAR'
            }
        },
        'fr-SN': {
            'CtryNm': 'SENEGAL',
            'CcyNm': 'CFA Franc BCEAO',
            'currency': {
                'style': 'currency',
                'currency': 'XOF'
            }
        },
        'sr-RS': {
            'CtryNm': 'SERBIA',
            'CcyNm': 'Serbian Dinar',
            'currency': {
                'style': 'currency',
                'currency': 'RSD'
            }
        },
        'en-SC': {
            'CtryNm': 'SEYCHELLES',
            'CcyNm': 'Seychelles Rupee',
            'currency': {
                'style': 'currency',
                'currency': 'SCR'
            }
        },
        'en-SL': {
            'CtryNm': 'SIERRA LEONE',
            'CcyNm': 'Leone',
            'currency': {
                'style': 'currency',
                'currency': 'SLL'
            }
        },
        'en-SG': {
            'CtryNm': 'SINGAPORE',
            'CcyNm': 'Singapore Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'SGD'
            }
        },
        'nl-SX': {
            'CtryNm': 'SINT MAARTEN (DUTCH PART)',
            'CcyNm': 'Netherlands Antillean Guilder',
            'currency': {
                'style': 'currency',
                'currency': 'ANG'
            }
        },
        'sk-SK': {
            'CtryNm': 'SLOVAKIA',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'sl-SI': {
            'CtryNm': 'SLOVENIA',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'en-SB': {
            'CtryNm': 'SOLOMON ISLANDS',
            'CcyNm': 'Solomon Islands Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'SBD'
            }
        },
        'so-SO': {
            'CtryNm': 'SOMALIA',
            'CcyNm': 'Somali Shilling',
            'currency': {
                'style': 'currency',
                'currency': 'SOS'
            }
        },
        'en-ZA': {
            'CtryNm': 'SOUTH AFRICA',
            'CcyNm': 'Rand',
            'currency': {
                'style': 'currency',
                'currency': 'ZAR'
            }
        },
        'en-SS': {
            'CtryNm': 'SOUTH SUDAN',
            'CcyNm': 'South Sudanese Pound',
            'currency': {
                'style': 'currency',
                'currency': 'SSP'
            }
        },
        'es-ES': {
            'CtryNm': 'SPAIN',
            'CcyNm': 'Euro',
            'currency': {
                'style': 'currency',
                'currency': 'EUR'
            }
        },
        'ta-LK': {
            'CtryNm': 'SRI LANKA',
            'CcyNm': 'Sri Lanka Rupee',
            'currency': {
                'style': 'currency',
                'currency': 'LKR'
            }
        },
        'en-SD': {
            'CtryNm': 'SUDAN (THE)',
            'CcyNm': 'Sudanese Pound',
            'currency': {
                'style': 'currency',
                'currency': 'SDG'
            }
        },
        'nl-SR': {
            'CtryNm': 'SURINAME',
            'CcyNm': 'Surinam Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'SRD'
            }
        },
        'nb-SJ': {
            'CtryNm': 'SVALBARD AND JAN MAYEN',
            'CcyNm': 'Norwegian Krone',
            'currency': {
                'style': 'currency',
                'currency': 'NOK'
            }
        },
        'sv-SE': {
            'CtryNm': 'SWEDEN',
            'CcyNm': 'Swedish Krona',
            'currency': {
                'style': 'currency',
                'currency': 'SEK'
            }
        },
        'de-CH': {
            'CtryNm': 'SWITZERLAND',
            'CcyNm': 'Swiss Franc',
            'currency': {
                'style': 'currency',
                'currency': 'CHF'
            }
        },
        'ar-SY': {
            'CtryNm': 'SYRIAN ARAB REPUBLIC',
            'CcyNm': 'Syrian Pound',
            'currency': {
                'style': 'currency',
                'currency': 'SYP'
            }
        },
        'zh-TW': {
            'CtryNm': 'TAIWAN (PROVINCE OF CHINA)',
            'CcyNm': 'New Taiwan Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'TWD'
            }
        },
        'en-TZ': {
            'CtryNm': 'TANZANIA, UNITED REPUBLIC OF',
            'CcyNm': 'Tanzanian Shilling',
            'currency': {
                'style': 'currency',
                'currency': 'TZS'
            }
        },
        'th-TH': {
            'CtryNm': 'THAILAND',
            'CcyNm': 'Baht',
            'currency': {
                'style': 'currency',
                'currency': 'THB'
            }
        },
        'pt-TL': {
            'CtryNm': 'TIMOR-LESTE',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'fr-TG': {
            'CtryNm': 'TOGO',
            'CcyNm': 'CFA Franc BCEAO',
            'currency': {
                'style': 'currency',
                'currency': 'XOF'
            }
        },
        'en-TK': {
            'CtryNm': 'TOKELAU',
            'CcyNm': 'New Zealand Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'NZD'
            }
        },
        'en-TO': {
            'CtryNm': 'TONGA',
            'CcyNm': 'Pa’anga',
            'currency': {
                'style': 'currency',
                'currency': 'TOP'
            }
        },
        'en-TT': {
            'CtryNm': 'TRINIDAD AND TOBAGO',
            'CcyNm': 'Trinidad and Tobago Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'TTD'
            }
        },
        'fr-TN': {
            'CtryNm': 'TUNISIA',
            'CcyNm': 'Tunisian Dinar',
            'currency': {
                'style': 'currency',
                'currency': 'TND'
            }
        },
        'tr-TR': {
            'CtryNm': 'TURKEY',
            'CcyNm': 'Turkish Lira',
            'currency': {
                'style': 'currency',
                'currency': 'TRY'
            }
        },
        'en-TC': {
            'CtryNm': 'TURKS AND CAICOS ISLANDS (THE)',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'en-TV': {
            'CtryNm': 'TUVALU',
            'CcyNm': 'Australian Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'AUD'
            }
        },
        'en-UG': {
            'CtryNm': 'UGANDA',
            'CcyNm': 'Uganda Shilling',
            'currency': {
                'style': 'currency',
                'currency': 'UGX'
            }
        },
        'uk-UA': {
            'CtryNm': 'UKRAINE',
            'CcyNm': 'Hryvnia',
            'currency': {
                'style': 'currency',
                'currency': 'UAH'
            }
        },
        'ar-AE': {
            'CtryNm': 'UNITED ARAB EMIRATES (THE)',
            'CcyNm': 'UAE Dirham',
            'currency': {
                'style': 'currency',
                'currency': 'AED'
            }
        },
        'en-GB': {
            'CtryNm': 'UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND(THE)',
            'CcyNm': 'Pound Sterling',
            'currency': {
                'style': 'currency',
                'currency': 'GBP'
            }
        },
        'en-UM': {
            'CtryNm': 'UNITED STATES MINOR OUTLYING ISLANDS (THE)',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'en-US': {
            'CtryNm': 'UNITED STATES OF AMERICA (THE)',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'es-UY': {
            'CtryNm': 'URUGUAY',
            'CcyNm': 'Peso Uruguayo',
            'currency': {
                'style': 'currency',
                'currency': 'UYU'
            }
        },
        'uz-UZ': {
            'CtryNm': 'UZBEKISTAN',
            'CcyNm': 'Uzbekistan Sum',
            'currency': {
                'style': 'currency',
                'currency': 'UZS'
            }
        },
        'en-VU': {
            'CtryNm': 'VANUATU',
            'CcyNm': 'Vatu',
            'currency': {
                'style': 'currency',
                'currency': 'VUV'
            }
        },
        'es-VE': {
            'CtryNm': 'VENEZUELA (BOLIVARIAN REPUBLIC OF)',
            'CcyNm': 'Bolívar Soberano',
            'currency': {
                'style': 'currency',
                'currency': 'VES'
            }
        },
        'vi-VN': {
            'CtryNm': 'VIET NAM',
            'CcyNm': 'Dong',
            'currency': {
                'style': 'currency',
                'currency': 'VND'
            }
        },
        'en-VG': {
            'CtryNm': 'VIRGIN ISLANDS (BRITISH)',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'en-VI': {
            'CtryNm': 'VIRGIN ISLANDS (U.S.)',
            'CcyNm': 'US Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'USD'
            }
        },
        'fr-WF': {
            'CtryNm': 'WALLIS AND FUTUNA',
            'CcyNm': 'CFP Franc',
            'currency': {
                'style': 'currency',
                'currency': 'XPF'
            }
        },
        'ar-EH': {
            'CtryNm': 'WESTERN SAHARA',
            'CcyNm': 'Moroccan Dirham',
            'currency': {
                'style': 'currency',
                'currency': 'MAD'
            }
        },
        'ar-YE': {
            'CtryNm': 'YEMEN',
            'CcyNm': 'Yemeni Rial',
            'currency': {
                'style': 'currency',
                'currency': 'YER'
            }
        },
        'en-ZM': {
            'CtryNm': 'ZAMBIA',
            'CcyNm': 'Zambian Kwacha',
            'currency': {
                'style': 'currency',
                'currency': 'ZMW'
            }
        },
        'en-ZW': {
            'CtryNm': 'ZIMBABWE',
            'CcyNm': 'Zimbabwe Dollar',
            'currency': {
                'style': 'currency',
                'currency': 'ZWL'
            }
        }
    }
}
